import { RouterModule } from '@angular/router';
import { ToneListComponent } from './tone_list/tone-list.component';
const routes = [
    {
        path: '',
        component: ToneListComponent
    }
];
export const routing = RouterModule.forRoot(routes);
//# sourceMappingURL=app.routing.js.map